import { getUserSelectableCountries } from '@change-corgi/config/countries';

import type { FormValues } from '#src/app/pages/petitionDetails/shared/types';
import { getStateCodes, isPostalCodeRequired, isStateRequired } from '#src/app/pages/petitionDetails/shared/utilities';

export function normalizeGeolocalizationValues({
	countryCode,
	city,
	postalCode,
	stateCode,
}: Pick<FormValues, 'countryCode' | 'city' | 'postalCode' | 'stateCode'>):
	| Pick<FormValues, 'countryCode' | 'city' | 'postalCode' | 'stateCode'>
	| undefined {
	if (!getUserSelectableCountries().includes(countryCode)) return undefined;
	if (isPostalCodeRequired({ countryCode }) && !postalCode) return undefined;
	if (isStateRequired({ countryCode }) && (!stateCode || !getStateCodes({ countryCode }).includes(stateCode)))
		return undefined;

	return {
		countryCode,
		city,
		postalCode: isPostalCodeRequired({ countryCode }) ? postalCode : '',
		stateCode: isStateRequired({ countryCode }) ? stateCode : '',
	};
}
